import { z } from 'zod';

export const datasetDTOSchema = z.object({
  datasetId: z.number().int(),
  organizationId: z.string().min(1),
  roadmapId: z.number().int(),
  allowedItemIds: z.array(z.number().int()),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type DatasetDTO = z.infer<typeof datasetDTOSchema>;

export const datasetUpdateDTOSchema = z
  .object({
    allowedItemIds: z.array(z.number().int()),
  })
  .strict();

export type DatasetUpdateDTO = z.infer<typeof datasetUpdateDTOSchema>;

export const datasetStageDTOSchema = z
  .object({
    sessionId: z.string().uuid(),
    allowedItemIds: z.array(z.number().int()),
  })
  .strict();

export type DatasetStageDTO = z.infer<typeof datasetStageDTOSchema>;

export const datasetCommitDTOSchema = z
  .object({
    sessionId: z.string().uuid(),
  })
  .strict();

export type DatasetCommitDTO = z.infer<typeof datasetCommitDTOSchema>;

export const datasetCommitResponseDTOSchema = z.object({
  added: z.number().int(),
  removed: z.number().int(),
});

export type DatasetCommitResponseDTO = z.infer<typeof datasetCommitResponseDTOSchema>;
